import { FormasIntegracao, PeriodoAcesso, SistemasIntegrado, Solicitante } from './solicitacao';

export class OperadorCadsus {
  dsEmail: string;
  noArea: string;
  noSetor: string;
  nuCnes: number;
  nuCns: string;
  nuDdd: number;
  nuTelefone: string;
}

export class SistemaPNI {
  dsArquitetura: string;
  dsSistemaSolicitante: string;
  dtMes: string;
  formasIntegracao: FormasIntegracao[];
  noBancoDeDados: string;
  noEmpresa: string;
  noLinguagem: string;
  noOutros: string;
  noSistemaSolicitante: string;
  nuIpFinal: string;
  nuIpInicial: string;
  nuVersao: string;
  nuVersaoBanco: string;
  operadorCadsus: OperadorCadsus;
  periodoAcessoModel: PeriodoAcesso[];
  qtAtendimento: string;
  sistemasIntegrados: SistemasIntegrado[];
  stAplicacaoWeb: string;
  stEmpresaPrivada: string;

  constructor() {
    this.operadorCadsus = new OperadorCadsus();
    this.formasIntegracao = [];
    this.sistemasIntegrados = [];
  }
}

export class SolicitacaoFrontend {
  idRascunho: number;
  concluida: boolean;
  isInterno: boolean;
  nuAno: number;
  nuSolicitacao: number;
  api: any;

  constructor(api) {
    this.idRascunho = new Date().getTime();
    this.concluida = false;
    this.api = api;
  }
}

export class PortfolioSolicitadoModel {
  idPortfolioSolicitado: number;
  idPortfolio: number;
  dtFimPicoAcesso: string;
  dtInicioPicoAcesso: string;
  qtAcessoPeriodoPico: number;
  qtMaximoAcessoDia: number;
  qtMinimoAcessoDia: number;
  servicos: ServicoSolicitado[];
  esferaSolicitacaoModel: any;
}

export class ServicoSolicitado {
  id: number;
  operacaoSolicitadas: OperacaoSolicitada[];
}

export class OperacaoSolicitada {
  id: number;
  name: string;
}


export class SolicitanteInterno {
  nuCns: number;
  dsLocalArea: string;
  noArea: string;
  sgArea: string;
}

export class SolicitanteExterno {
  cnes: number;
  cns: number;
  dsEmail: string;
  noFantasia: string;
  noRazaoSocial: string;
  nuDdd: number;
  nuTelefone: number;
  nuCnpj: string;
}

export class CrendencialModel {
    dsAmbiente: string;
    dsCertificado: string;
    dsExpoentCertificado: string;
    dsModulusCertificado: string;
    dsSenhaCertificado: string;
    dsSenhaUsuario: string;
    dtInsercao: string;
    noUsuario: string;
    periodoMaiorAcesso: string;
    stCredencial: string;
    stRegistroAtivo: string;
    nuCnpjCertificado: string;
}

export class SolicitacaoPNI {

  credencialModel?: CrendencialModel;
  estabelecimentosFilhos?: { nuCnes: number; }[];
  solicitante?: Solicitante | SolicitanteInterno | SolicitanteExterno;
  noUsuario: string;
  nuCnes: number;
  portfolioSolicitadoModel?: PortfolioSolicitadoModel;
  sistema: SistemaPNI;

  constructor() {
    this.sistema = new SistemaPNI();
    this.solicitante = new Solicitante();
  }
}

export class Solicitacao {
  solicitado: SolicitacaoPNI;
  form: { [ key: string ]: any };
  frontend: SolicitacaoFrontend;

  constructor(api) {
    Object.setPrototypeOf(this, Solicitacao.prototype);
    this.form = {};
    this.frontend = new SolicitacaoFrontend(api);
  }
}






// WEBPACK FOOTER //
// ./src/app/model/solicitacao-pni.ts